 
import React, { ReactElement } from 'react';

import { SkeletonBase } from '@digital-dealer/components';

const MobileSkeleton = (): ReactElement => (
  <SkeletonBase viewBox="0 0 343 680">
    <rect
      width="343"
      height="160"
      rx="4"
    />
    <rect
      y="172"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      y="200"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      y="232"
      width="343"
      height="160"
      rx="4"
    />
    <rect
      y="404"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      y="432"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      y="464"
      width="343"
      height="160"
      rx="4"
    />
    <rect
      y="636"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      y="664"
      width="149"
      height="16"
      rx="4"
    />
  </SkeletonBase>
);

export default MobileSkeleton;
